import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuthStore } from "@/store/auth-store";

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();

  // Get the URL that was attempted to be accessed
  const attemptedPath = location.state?.from?.pathname || "/";

  // Handle navigation back to safe location
  const handleBackToSafety = () => {
    navigate(attemptedPath);
  };

  // Handle logout
  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="bg-red-600 p-4">
          <div className="flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-12 w-12 text-white"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>

        <div className="p-6">
          <h1 className="text-2xl font-bold text-gray-900 text-center mb-2">
            Access Denied
          </h1>

          <div className="flex items-center justify-center my-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
          </div>

          <p className="text-gray-600 text-center mb-4">
            You don't have permission to access {attemptedPath}.
          </p>

          {user && (
            <div className="bg-gray-50 p-4 rounded-md mb-6">
              <p className="text-sm text-gray-600">
                Logged in as:{" "}
                <span className="font-medium">
                  {user.first_name} {user.last_name}
                </span>
              </p>
              {user.groups.length > 0 && (
                <p className="text-sm text-gray-600 mt-1">
                  Your role(s): {user.groups.join(", ")}
                </p>
              )}
            </div>
          )}

          <p className="text-sm text-gray-500 mb-6">
            If you believe you should have access to this page, please contact
            your administrator for assistance or try logging in with a different
            account.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={handleBackToSafety}
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              Back to Home
            </Button>

            <Button
              onClick={handleLogout}
              variant="outline"
              className="border-gray-300 text-gray-700"
            >
              Logout
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
